export default __webpack_public_path__ + "static/6907-5afc0b0225f3b0dad5e40cd978375ed3.jpg";